<template>
  <div class="CertificationList">
          <div class="row CertificationBody"> 
              <div class="Certification_nav" 
                  v-for="(item, index) in temp_Value" 
                  :key="index" 
              >
                <div class="Certification_block">
                    <div class="CertificationType">
                        <selection 
                            :title="$t('lbl_EMPBE_CompanyInfo_Certification_certificationType_PlaceOther')" label="Name"
                            :name="'type_'+index" 
                            v-model="item.certificationType"
                            :ControlId="'type_'+index" 
                            :options="temp_CertificationTypeOptions"
                            :multiple="false" 
                            :preselect-first="true">
                          </selection>
                        <ProductFieldApprovalResults
                          usage-type="CertificationType"
                          :usage-id="certRowId(item)"
                        />
                    </div>
                    <div class="CertificationName">
                          <textbox 
                                :ControlId="'name_'+index" 
                                :title="$t('lbl_EMPBE_CompanyInfo_Certification_certificationName_PlaceOther')" 
                                type="text"
                                v-model="item.certificationName"
                                >
                            </textbox>
                        <ProductFieldApprovalResults
                          usage-type="CertificationName"
                          :usage-id="certRowId(item)"
                        />
                    </div>
                    <div class="CertificationUpload">
                        <div class="CertificationUpload_Title">
                          {{ $t("lbl_EMPBE_CompanyInfo_Certification_certificationFile")}} 
                        </div>
                        <div class="uploadModel">
                          <MediaApprovalGallery
                            v-if="shouldShowMediaApprovalGallery(certImageList[index])"
                            :MediaArray="certImageList[index]"
                            mode="admin"
                            media-type="image"
                            gallery-item-style="height: 120px; width: 85px;"
                            :title="$t('lbl_EMPBE_CompanyInfo_Certification_certificationFile')"
                            :approval-content-results="getMediaApprovalResults('eBooth_Exhibit_Certificate,ExhibitCertification')"
                            :approval-content-result-drafts="getMediaApprovalDraftMap('eBooth_Exhibit_Certificate,ExhibitCertification', certImageList[index])"
                            :rejection-templates="mediaApprovalRejectionTemplates"
                            :rejection-actor="mediaApprovalRejectionActor"
                            @approval-draft-change="onMediaApprovalDraftChange('eBooth_Exhibit_Certificate,ExhibitCertification', $event)"
                          />
                          <template v-else>
                            <mediaUploader
                              :MediaArray="certImageList[index]"
                              :limit="1" 
                              :isDisabled="isApprovalMediaReadOnly"
                              aspectRatioStr="1:1.414" 
                              galleryItemStyle="height: 120px; width: 85px;" 
                              mediaType="image"
                              :key="'certMediaUploader_'+index+'_'+(certMediaFileId(item)||certMediaFileName(item)||'empty')"
                              :ref="'certMediaUploader_'+index"
                              fileUsageType="eBooth_Exhibit_Certificate"
                              filePathEndpoint="Image"
                              :reject-records="getMediaRejectRecords('eBooth_Exhibit_Certificate,ExhibitCertification', certImageList[index])"
                              @update="(cmd, files) => handlerUploaderUpdateData(cmd, files, index)"
                            />
                            <MediaRejectBanner :records="getMediaRejectRecords('eBooth_Exhibit_Certificate,ExhibitCertification', certImageList[index])" />
                          </template>
                        </div>
                    </div>
                </div>
                <div class="Certification_Del">
                  <a href="javascript:;" ><img :src="cdnURL+'DelSale_Enquiry.svg'" @click="DelCertification(index)"/></a>
                </div>
              </div>
          </div>
           <b-button  v-if="temp_Value.length<nums"
                    class="btn btn-outline-primary p-l-15 d-flex align-items-center" variant="outline-primary"
                    @click="AddCertification"
                     v-bind:t_label="'EMPBE_Other_contract_info_add'">
                    <feather type="plus-circle"> </feather>
                    &nbsp; {{ $t("lbl_EMPBE_CompanyInfo_Certification_AddButtom")}}
                </b-button>

  </div>
</template>
<script>
import mediaUploader from "../../../components/form/upload/imgUploader/mediaUploader.vue";
import MediaRejectBanner from "../../../components/form/upload/imgUploader/mediaRejectBanner.vue";
import MediaApprovalGallery from "../../../components/form/upload/imgUploader/mediaApprovalGallery.vue";
import mediaApprovalGalleryBridge from "../../../components/form/upload/imgUploader/mediaApprovalGalleryBridge.js";
import ProductFieldApprovalResults from "../ProductFieldApprovalResults.vue";
import {
  getInitImageDataObj,
} from '@/_helpers/media-uploader-utils.js';
import {
  getDeleteOSSUrlOnDbCommand
} from '@/_helpers/utility.js';

export default {
    mixins: [mediaApprovalGalleryBridge],
    components: {
      mediaUploader,
      MediaRejectBanner,
      MediaApprovalGallery,
      ProductFieldApprovalResults,
    },
    props: ["value",'nums','CertificationTypeOptions',"supplierId","ProductId"],
    inject: {
      productApprovalHost: { default: null },
    },
    data(){
        return{
            temp_Value:this.value,
            certImageList: [],
            temp_CertificationTypeOptions:this.CertificationTypeOptions,
            cdnURL:"https://cdn.adsalecdn.com/EMP/Backend/svg/CompanyInfo/",
            Init_Certification:
            {
                rid: undefined,
                empCompanyId: this.supplierId,
                certificationType: "",
                certificationName: "",
                orderId: undefined,
                ProductId: this.ProductId,
                isPendingInsert: true,
                updateFileCommands: [],
                pendingFiles: [],
            }
        }
    },
    watch:{
      value: {
        handler(newVal, oldVal) {
          this.temp_Value = newVal;
          // 与公司图库一致：仅在行数 / 已入库文件变化时同步 MediaArray
          if (this.shouldResyncCertImages(newVal, oldVal)) {
            this.syncCertImageList(newVal);
          }
        },
        immediate: true,
      },
      temp_Value: {
          handler(newValue) {
              this.$emit("input", newValue);
          },
          deep:true
      },
      CertificationTypeOptions: {
          handler(newVal) {
              this.temp_CertificationTypeOptions = newVal;
          },
          deep:true
      },
    },
    methods: {
      /** media.id = MediaFile.RID = Approval_Request_Content.UsageId（MEDIA） */
      certMediaFileId(item) {
        if (!item) return null;
        const id = item.fileID ?? item.fileId ?? item.FileID ?? null;
        return id == null || id === '' ? null : id;
      },
      certMediaFileName(item) {
        if (!item) return null;
        const name = item.fileName ?? item.FileName ?? null;
        return name == null || String(name).trim() === '' ? null : name;
      },
      shouldResyncCertImages(newVal, oldVal) {
        if (oldVal == null) return true;
        const next = Array.isArray(newVal) ? newVal : [];
        const prev = Array.isArray(oldVal) ? oldVal : [];
        if (next.length !== prev.length) return true;
        return next.some((item, i) => {
          const p = prev[i];
          if (!p) return true;
          return String(this.certMediaFileId(item) ?? '') !== String(this.certMediaFileId(p) ?? '')
            || String(this.certMediaFileName(item) ?? '') !== String(this.certMediaFileName(p) ?? '');
        });
      },
      syncCertImageList(list) {
        const rows = Array.isArray(list) ? list : [];
        const prev = Array.isArray(this.certImageList) ? this.certImageList : [];
        this.certImageList = rows.map((item, index) => {
          const fileId = this.certMediaFileId(item);
          const fileName = this.certMediaFileName(item);
          if (fileId && fileName) {
            return [
              getInitImageDataObj(
                { rid: fileId, fileName, orderId: item.orderId ?? item.OrderId ?? 0 },
                {
                  id: fileId,
                  cdnLink: fileName,
                  orderId: item.orderId ?? item.OrderId ?? 0,
                  usageType: "eBooth_Exhibit_Certificate",
                },
              ),
            ];
          }
          const existing = prev[index];
          return Array.isArray(existing) ? existing : [];
        });
      },
      /** 认证行 RID，与 LIST_COLUMN（Type/Name）的 UsageId 对齐 */
      certRowId(item) {
        if (!item) return null;
        const id = item.rid ?? item.RID ?? item.Rid;
        return id == null || id === '' ? null : id;
      },
      AddCertification() {
        var newCertification = JSON.parse(JSON.stringify(this.Init_Certification));
        const currLength = this.temp_Value.length;
        newCertification.orderId = currLength + 1;
        this.certImageList.push([]);
        this.temp_Value.push(newCertification);
      },
      DelCertification(index) {
        const isPendingInsert = this.temp_Value[index].isPendingInsert;
        if (!isPendingInsert) {
          const deleteItem = this.certImageList[index]?.length > 0 ? this.certImageList[index][0] : null;
          const deleteCommand = getDeleteOSSUrlOnDbCommand(deleteItem?.id ?? 0, deleteItem?.cdnLink ?? "", deleteItem?.orderId ?? 0, deleteItem?.usageType ?? "");
          this.$emit("removeCertImage", deleteCommand);
        }
        this.certImageList.splice(index,1);
        this.temp_Value.splice(index,1);
      },
      // 与 logoAndImage 一致：只存 pendingFiles / commands，不回写 MediaArray
      handlerUploaderUpdateData(commands, pendingFiles, index) {
        this.$set(this.temp_Value[index], "updateFileCommands", commands);
        this.$set(this.temp_Value[index], "pendingFiles", pendingFiles);
      },
    }

}
</script>
<style lang="scss" scoped>
.CertificationBody{
  .Certification_nav
  {
    display: flex;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    margin-bottom: 18px;
    width: 100%;
    .Certification_block
    {
      padding: 24px;
      border-radius: 16px;
      border: 1px solid var(--outline-10, rgba(0, 0, 0, 0.10));
    }
  }
  .CertificationUpload
  {
    .uploadModel
    {
      margin-top: 8px;
    }
  }
}
</style>
